import { parseFetchAllRequest as parseAllRequest } from 'containers/App/modules/entities/users/users.parsers';

// Convert generic grid payload into SearchRequestV2-compatible body for the events API.
// The grid stores the toolbar time range as entryTimestampAfter / entryTimestampBefore, but we
// send it as creationTime: { from, to } (cloud ingestion time), NOT entryTimestamp (device time).
// ProcessingData has no index on entryTimestamp: with it, the per-page COUNT(*) reads every row
// of the device (70 s for a 175K-row device, minutes for a busy one — measured on staging), while
// creationTime is covered by (deviceType, deviceSerialNumber, creationTime) and answers in <1 s.
export const parseFetchAllRequest = (payload) => {
	const base = parseAllRequest(payload) || {};
	const { filter: filterArray, sort, limit, page, search } = base;

	const filter = {};
	const entryTimestampRange = {};

	(filterArray || []).forEach((f) => {
		if (!f || !f.prop) return;
		const values = Array.isArray(f.values) ? f.values : (f.values != null ? [f.values] : []);
		if (values.length === 0) return;

		if (f.prop === 'entryTimestampAfter') {
			entryTimestampRange.from = values[0];
		} else if (f.prop === 'entryTimestampBefore') {
			entryTimestampRange.to = values[0];
		} else if (f.prop.endsWith('After')) {
			filter[f.prop] = { from: values[0] };
		} else if (f.prop.endsWith('Before')) {
			filter[f.prop] = { to: values[0] };
		} else {
			if (values.length === 1) {
				filter[f.prop] = { eq: values[0] };
			} else {
				filter[f.prop] = { in: values };
			}
		}
	});

	if (entryTimestampRange.from || entryTimestampRange.to) {
		filter.creationTime = entryTimestampRange;
	}

	const sortList = (sort || []).map((s) => ({
		prop: s.prop || s.key || s.field,
		order: (s.order || 'ASC').toUpperCase(),
	}));

	return {
		filter,
		freeTextSearch: search || undefined,
		sort: sortList,
		limit,
		page,
	};
};

export const parseFetchAllSuccess = (responseData) => {
	return responseData.data;
};
